import { takeLatest, call, select, put, all, takeEvery } from 'redux-saga/effects';
import { toggleMature, updateContentFilter, switchVersion, toggleTheme, toggleThemeDone, updateCommentsOrder, updateCommentsOrderDone, resendVerificationEmail, updateEmail, resendVerificationEmailFail, resendVerificationEmailSuccess, updateEmailFail, updateEmailSuccess, setViewMode, setThemeSkin, setTheme } from './actions';
import { getTheme, getVerificationEmailAddress, getIsLoggedIn, getThemeSkin } from './selectors';
import { isApiError, requestPuppy } from '@wix/da-http-client/pkg/request';
import { openUserDropdown } from '../SiteHeader/redux/actions';
import { DeviationViewMode } from '@wix/da-react-context/pkg/SessionContext';
import { ThemeSkin } from '@wix/da-react-context/pkg/ThemeContext';
import { restrictLoggedOut } from '../redux/loggedout';
import ddt from '@wix/da-ddt';
import { ReferralType } from '@wix/da-bi/pkg/constants';
const logger = ddt.createLogger('publicSession');
function* toggleMatureHandler(action) {
    if (!action.payload) {
        return;
    }
    const isLoggedIn = yield select(getIsLoggedIn);
    if (!isLoggedIn) {
        yield put(restrictLoggedOut({
            restrictedActionName: ReferralType.MATURE
        }));
        return;
    }
    const { current } = action.payload;
    const result = yield call(requestPuppy, {
        method: 'post',
        url: '/user/settings/mature',
        data: {
            flag: !current
        }
    }, ()=>({
            success: true
        }));
    if (result && result.success) {
        window.location.reload();
    } else {
        if (result.error_code === 0) {
            alert('Error, you are too young to enable mature content');
            return;
        }
        alert('Failed to save mature setting');
    }
}
function* updateContentFilterHandler(action) {
    if (!action.payload) {
        return;
    }
    const isLoggedIn = yield select(getIsLoggedIn);
    if (!isLoggedIn) {
        yield put(restrictLoggedOut({
            restrictedActionName: ReferralType.MATURE
        }));
        return;
    }
    const { contentFilter } = action.payload;
    const result = yield call(requestPuppy, {
        method: 'post',
        url: '/user/settings/content_filter',
        data: {
            content_filter: contentFilter
        }
    }, ()=>({
            success: true
        }));
    if (result && result.success) {
        window.location.reload();
    } else {
        alert([
            'Failed to save setting:',
            `  setting: ${contentFilter}`,
            `  ${result.errorDescription}`
        ].join('\n'));
    }
}
function* switchVersionHandler(action) {
    if (!action.payload) {
        return;
    }
    const result = yield call(requestPuppy, {
        method: 'post',
        url: '/user/releaseswitch',
        data: {
            is_da_version_9_1: true
        }
    }, ()=>({
            success: true
        }));
    if (result && result.success) {
        window.location.reload();
    } else {
        alert('Failed to switch version please try again');
    }
}
function* saveThemeHandler() {
    // Reducer will have updated it
    const currentTheme = yield select(getTheme);
    const currentThemeSkin = yield select(getThemeSkin);
    let themeToSet = currentTheme;
    if (currentThemeSkin === ThemeSkin.GREEN) {
        themeToSet = 'green';
    }
    const result = yield call(requestPuppy, {
        method: 'post',
        url: '/user/theme',
        data: {
            theme: themeToSet
        }
    }, ()=>({
            success: true
        }));
    if (!result || !result.success) {
        alert('Failed to save theme setting');
        return;
    }
    yield put(toggleThemeDone());
}
function* updateCommentsOrderHandler({ payload }) {
    if (!payload) {
        return;
    }
    const data = {
        order: payload.order
    };
    const result = yield call(requestPuppy, {
        method: 'post',
        url: '/user/settings/comments_order',
        data
    }, ()=>({
            success: true
        }));
    if (!result || !result.success) {
        alert('Failed to save comments order');
        return;
    }
    yield put(updateCommentsOrderDone(payload.order));
}
function* resendVerificationEmailHandler() {
    yield put(openUserDropdown());
    const data = {};
    const result = yield call(requestPuppy, {
        method: 'post',
        url: '/user/resend_verification_email',
        data
    }, ()=>({
            success: true
        }));
    if (!result || !result.success) {
        alert('Failed to resend email');
        yield put(resendVerificationEmailFail());
        return;
    }
    yield put(resendVerificationEmailSuccess());
}
function* updateEmailHandler({ payload }) {
    if (!payload) {
        return;
    }
    const { email } = payload;
    const currentEmail = yield select(getVerificationEmailAddress);
    // it's as good as done so whatever
    if (email === currentEmail) {
        yield put(updateEmailSuccess(email));
        return;
    }
    const data = {
        email
    };
    const result = yield call(requestPuppy, {
        method: 'post',
        url: '/user/update_email',
        data
    }, ()=>({
            success: true
        }));
    if (!result || !result.success) {
        yield put(updateEmailFail(email));
        return;
    }
    yield put(updateEmailSuccess(email));
}
function* setViewModeHandler({ payload: { nextViewMode } }) {
    // only save normal/theater, fullscreen is irrelevant
    if (nextViewMode === DeviationViewMode.Fullscreen) {
        return;
    }
    const data = {
        view_mode: nextViewMode
    };
    const result = yield call(requestPuppy, {
        method: 'post',
        url: 'set_view_mode',
        data
    }, ()=>({
            success: true
        }), 'dadeviation');
    if (!result || isApiError(result)) {
        logger.error('Failed to persist new view mode', nextViewMode);
    }
}
export default function* saga() {
    yield all([
        takeLatest(switchVersion, switchVersionHandler),
        takeLatest(toggleMature, toggleMatureHandler),
        takeLatest(updateContentFilter, updateContentFilterHandler),
        takeLatest(toggleTheme, saveThemeHandler),
        takeLatest(setTheme, saveThemeHandler),
        takeLatest(setThemeSkin, saveThemeHandler),
        takeLatest(updateCommentsOrder, updateCommentsOrderHandler),
        takeLatest(resendVerificationEmail, resendVerificationEmailHandler),
        takeLatest(updateEmail, updateEmailHandler),
        takeEvery(setViewMode, setViewModeHandler)
    ]);
}
